$(document).ready(function () {
    const $banner = $('#campaign-banner');
    const token = localStorage.getItem('token');
    const userId = localStorage.getItem('user_id');

    if (!$banner.length || !token || !userId) {
        return;
    }

    const escapeHtml = function (value) {
        return String(value == null ? '' : value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    };

    const isSafeUrl = function (url) {
        return /^(https?:\/\/|\/)/i.test(url || '');
    };

    const render = function (banner) {
        const title = banner.title ? '<h2 class="campaign-banner__title">' + escapeHtml(banner.title) + '</h2>' : '';
        const description = banner.description ? '<p class="campaign-banner__description">' + escapeHtml(banner.description) + '</p>' : '';
        const content = '<div class="container campaign-banner__content">' + title + description + '</div>';
        const hasText = !!(title || description);

        const inner = isSafeUrl(banner.url)
            ? '<a class="campaign-banner__link" href="' + escapeHtml(banner.url) + '"'
                + (banner.external ? ' target="_blank" rel="noopener noreferrer"' : '')
                + ' aria-label="' + escapeHtml(banner.title || 'Banner de campanhas') + '">' + content + '</a>'
            : content;

        $banner
            .toggleClass('campaign-banner--has-text', hasText)
            .css('background-image', 'url("' + encodeURI(banner.image_url) + '")')
            .html(inner)
            .removeClass('d-none');
    };

    $.ajax({
        url: '/api/campaigns/banner',
        method: 'GET',
        dataType: 'json',
        global: false,
        headers: Object.assign(
            {},
            window.$headerAuth || { Authorization: 'Bearer ' + token },
            { 'X-User-Id': userId }
        )
    }).done(function (banner) {
        if (banner && banner.image_url) {
            render(banner);
        }
    });
});
